<template>
  <div class="safety-mode-refresh-alert"></div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';

@Component()
export default class SafetyModeRefreshAlert extends Vue {
  created () {
    window.addEventListener('beforeunload', this.exitAlert);
  }

  exitAlert (e) {
    const text = this.$t('SpringboardVR is in Safety Mode because it\'s experiencing issues. If you leave now, you won\'t be able to return to the Station Monitor until the issues are fixed. You do not need to refresh the page to regain functionality of the Station Monitor screen. This will happen automatically when the servers come back online.');
    e.returnValue = text;
    return text;
  }

  beforeDestroy () {
    window.removeEventListener('beforeunload', this.exitAlert);
  }
}
</script>
